module.exports = {"data":{"file":{"childImageSharp":{"responsiveResolution":{"src":"/static/fx-061c7fd2aca267f718382067bbaa14cf-f6f0c.png"}}}},"pathContext":{"slug":"/en/about/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-about.json
// module id = 728
// module chunks = 63962516548452